import Image from "next/image";

import Badge from "~/componentsDS/Badge";
import Paragraph from "~/componentsDS/Typography/Paragraph";

import type { Clinician } from "./data";
import Lead from "~/componentsDS/Typography/Lead";

type ClinicianCardProps = {
    clinician: Clinician;
};

export default function ClinicianCard({
    clinician,
}: ClinicianCardProps) {
    const { experience, highlight, imageUrl, name } = clinician;

    return (
        <article className="relative aspect-[352/440] overflow-hidden rounded-xl lg:aspect-[360/480]">
            <Image
                src={imageUrl}
                alt={name}
                fill
                quality={95}
                sizes="(max-width: 1023px) calc(100vw - 48px), 360px"
                loading="lazy"
                className="object-cover object-top"
            />

            <div
                aria-hidden="true"
                className="absolute inset-x-0 bottom-0 h-[38%] bg-gradient-to-t from-trueBlack/40 via-trueBlack/10 to-transparent"
            />

            <div className="absolute inset-x-0 bottom-6 flex flex-col items-center px-3 text-center text-pureWhite">
                <Lead font="featureDisplay" className="text-[24px]">
                    {name}
                </Lead>

                {highlight && (
                    <Badge
                        variant="secondary"
                        size="md"
                        className="mt-[14px] whitespace-nowrap px-3"
                    >
                        <Paragraph
                            as="span"
                            weight="500"
                            className="text-trueBlack pt-[2px]"
                        >
                            {highlight}
                        </Paragraph>
                    </Badge>
                )}

                {experience && (
                    <Paragraph
                        weight="500"
                        className="mt-[14px] whitespace-nowrap"
                    >
                        {experience}
                    </Paragraph>
                )}
            </div>
        </article>
    );
}
